import React from 'react';
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig
} from '@/components/ui/chart';
import { Pie, PieChart, Cell, PieProps } from 'recharts';

interface IndustryData {
  name: string;
  value: number;
  color: string;
}

interface IndustryDistributionProps {
  data: IndustryData[];
  PieProps?: Omit<PieProps, 'ref'>;
  legendClass?: string;
}

const IndustryDistribution: React.FC<IndustryDistributionProps> = ({
  data,
  PieProps = {},
  legendClass = ''
}) => {
  const chartConfig = data.reduce((config, item) => {
    config[item.name] = {
      label: item.name,
      color: item.color
    };
    return config;
  }, {} as ChartConfig);

  return (
    <div className="flex flex-col gap-4 flex-1 items-center">
      <div className="flex items-center gap-2">
        <span className="text-xs font-semibold text-gray-900">行业分布</span>
      </div>
      <div className="flex items-center gap-4">
        {/* 饼图 */}
        <div className="w-24 h-24">
          <ChartContainer config={chartConfig} className="h-full">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={20}
                outerRadius={40}
                paddingAngle={2}
                dataKey="value"
                {...PieProps}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <ChartTooltip content={<ChartTooltipContent />} />
            </PieChart>
          </ChartContainer>
        </div>

        {/* 图例 */}
        <div className={`flex flex-col gap-1 ${legendClass}`}>
          {data.map((item, index) => (
            <div key={index} className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-sm" style={{ backgroundColor: item.color }} />
              <span className="text-xs text-gray-900 whitespace-nowrap">{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IndustryDistribution;
